export default {
  heroTitle: "Время меняет всё.",
  heroAccent: "Исключая знания.",
  heroLead:
    "Эпохи сменяют друг друга, города меняются, но библиотека остаётся — хранилище знаний, открытое для каждого поколения.",
  ctaLogin: "Войти в аккаунт",
  ctaPortal: "Перейти в мероприятия",
  ctaEvents: "Мероприятия",
  ctaSearch: "Каталог",
  newsKicker: "Новости",
  newsTitle: "Что происходит в НБР",
  newsSubtitle: "Свежие материалы проекта — без ухода со страницы.",
  newsAll: "Все новости",
  newsEmpty: "Пока нет опубликованных новостей.",
  newsError: "Не удалось загрузить новости. Попробуйте позже.",
  newsVisualLead:
    "Книга — это больше, чем предмет. Это история, которая живёт веками.",
  catalogKicker: "Каталог",
  catalogTitle: "Библиография в цифрах",
  catalogSubtitle:
    "Записи живого каталога: лица, произведения и издания.",
  catalogCta: "Открыть каталог",
  catalogSearchCta: "Поиск",
  catalogQueryCta: "Подбор по условиям",
  catalogStatsUnavailable: "Статистика временно недоступна",
  catalogExploreAria: "Перейти в каталог Национального библиографического ресурса",
  depositKicker: "Авторское право",
  depositTitle: "Депонирование произведений",
  depositSubtitle:
    "Официальная регистрация и защита авторских прав на ваши произведения в фондах Российской государственной библиотеки.",
  depositHowTitle: "Как это работает",
  depositStep1Title: "Заполните форму",
  depositStep1Desc: "Укажите данные о произведении и авторе",
  depositStep2Title: "Загрузите файл",
  depositStep2Desc: "Прикрепите электронную версию произведения",
  depositStep3Title: "Получите свидетельство",
  depositStep3Desc: "Документ о депонировании придёт на email",
  depositRegistryTitle: "Публичный реестр",
  depositRegistryAll: "Все",
  depositApplyCta: "Подать заявку",
  depositApplyHint: "Заполните форму, загрузите файл и получите свидетельство",
  depositApplyAria: "Подать заявку на депонирование",
  depositExploreTitle: "Открыть полный реестр",
  depositExploreHint: "Сертифицированные произведения в фондах РГБ — поиск по категориям и номерам",
  depositExploreCount: "{{count}} записей в реестре",
  depositExploreAria: "Перейти к публичному реестру депонирования",
}
